import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class viaticosService {

  API_URI = environment.uri_api;

  constructor(private http: HttpClient) { }

  Listaempleadosviaticos(idplantel: number) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.get(`${this.API_URI}/listaempleadosviaticos/${idplantel}`, { headers: httpHeaders });
  }
  AgregarComprobacion(datos: any) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.post(`${this.API_URI}/agregarComprobacion`, datos, { headers: httpHeaders });
  }

  Verificalinea(datos: any) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.post(`${this.API_URI}/verificarlinea`, datos, { headers: httpHeaders });
  }

  Listafacturasfinancieros(noplantel:any) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });


    return this.http.get(`${this.API_URI}/listafinancieros/${noplantel}`, { headers: httpHeaders });
  }

  //////////////////////////////////


  ObtenerComprobacion(id: any) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });


    return this.http.get(`${this.API_URI}/comprobacion/${id}`, { headers: httpHeaders });
  }



  editarComprobacion(datos: any) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.post(`${this.API_URI}/editarcomprobacion`, datos, { headers: httpHeaders });
  }
  EliminarComprobacion(id: any) {
    console.log(id)
    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.post(`${this.API_URI}/eliminarcomprobacion/${id}`,  { headers: httpHeaders });
  }

  
  
  enviarComprobacion(datos: any) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.post(`${this.API_URI}/enviarcomprobacion`, datos, { headers: httpHeaders });
  }
  //////////////////////////// ALUMNOS REPROBRADOS EXCEL /////////////////////////////////////////////////

  getdatosgenerales(idplantel: any) {
    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.get(`${this.API_URI}/datosgenerales/${idplantel}`, { headers: httpHeaders });
  }
  //////////////////////////// ALUMNOS REPROBRADOS EXCEL /////////////////////////////////////////////////

  getdatoscomprobacion(id: any) {
    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.get(`${this.API_URI}/datoscomprobacion/${id}`, { headers: httpHeaders });
  }

  //////////////////////////// ELIMINAR XML /////////////////////////////////////////////////

  EliminarXML(id: any) {
    console.log(id)
    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.post(`${this.API_URI}/eliminarXML/${id}`, { headers: httpHeaders });
  }
}
